<template>
  <section class="login">
    <helpCenterBar ></helpCenterBar>
    <div class="container">
      <div class="login_form">
        <p>帮助后台登录</p>
          <span>用户名</span><input type="text" placeholder="用户名" v-model='sName'>
          <span>密码</span><input type="password" placeholder="密码" v-model='sPassword'>
          <!-- <input type="btn" class="btn" placeholder="登录"> -->
          <button class="btn" @click="sLogin" >登录</button>
          <!-- <s-btn>登录</s-btn>
          <s-btn :isSolid=false>登录登录登录登录登录</s-btn>
          <s-btn theme="danger">登录登录登录登录登录</s-btn>
          <s-btn size="normal">登录登录登录登录登录</s-btn>
          <s-btn theme="primary" size="large">登录登录登录登录登录</s-btn>
          <s-btn size="small">登录登录登录登录登录</s-btn> -->
      </div>
    </div>
  </section>
</template>
<script>
import Api from '@/api/api.js'
import SBtn from '@/components/SBtn'
import HelpCenterBar from '@/components/HelpCenterBar'
export default {
  /******************************************
  ** 组件名称
  * @description 组件描述
  * @author ah
  *****************************************
  prop1          <type>            <属性描述>
  *****************************************/
  name: 'component_name',
  components: { HelpCenterBar, SBtn },
  props: {},
  data () {
    return {
      sName: '',
      sPassword: ''

    }
  },
  computed: {},
  methods: {
    sLogin () {
      if (this.sName === '') {
        alert('用户名不能为空')
      } else if (this.sPassword === '') {
        alert('密码不能为空')
      } else {
        this.login()
      }
    },
    // oldLogin () {
    //   // axios默认可修改Cookie
    //   axios.defaults.withCredentials = true
    //   axios.post('http://192.168.1.161:7001/api/login', {
    //     UserName: this.sName,
    //     Password: this.sPassword
    //   }).then(res => {
    //     if (res.status === 200) {
    //       alert('success')
    //       console.log(res)
    //       this.$router.push('/')
    //     }
    //   })
    //     .catch(res => {
    //       alert('登录失败')
    //       console.log(res)
    //     })
    // },
    login () {
      // console.log('--------', this.sName)
      // console.log('--------', this.sPassword)

      Api.login(this.sName, this.sPassword)
        .then(res => {
          // console.log(res)
          if (res.data.role === 'admin') {
            this.$store.dispatch('setRoler', 'admin')
            this.$router.push('/')
          } else {
            alert('用户名或密码错误')
          }
          //
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="less" scoped>

.login{
  width: 100%;
  .container{
    // width: 1080px;
    width: 88%;
    height:402px;
    margin:0 auto;
    .login_form{
      // width: 406px;
      width: 2rem;
      margin:0 auto;
      // background-color: pink;
      p{
        margin:0.4rem auto;
        // margin:80px auto;
        font-size:0.16rem;
        // font-size:32px;
      }
      span,input {
        text-align: left;
        display: block;

      }
      span{
        font-size: 0.07rem;
        // font-size: 14px;
        margin-bottom:8px;
      }
      input {
        width: 2rem;
        // width: 406px;
        height: 0.2rem;
        // height: 40px;

        line-height: 0.2rem;
        padding-left:0.03rem;
        border: solid 1px #C0C0C0;
        border-radius:4px;
        margin-bottom:0.05rem;
        font-size: 0.06rem;
        color:#000;
      }
      .btn{
        width: 2.05rem;
        height: 0.2rem;
        background-color: #276BEE;
        border-radius:4px;
        color:#fff;
        margin-top:0.2rem;
        font-size: 0.08rem;
        text-align: center;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Login.vue